import { Injectable } from '@angular/core';

import { SurveyBhUserGrpcContractService } from '@lyra/app/core/api/grpc';
import { ErrorService } from '@lyra/app/core/services/error.service';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { catchError, filter, map, switchMap, withLatestFrom } from 'rxjs';

import { CALCULATE_AND_GET_RESULTS_COMMAND } from '../actions/questionnaire.actions';
import * as actions from '../actions/questions.actions';
import { QuestionnaireSelectService } from '../selectors/questionnaire.selector';
import { QuestionsSelectService } from '../selectors/questions.selector';
import { SurveySelectService } from '../selectors/survey.selector';
import { IQuestionnaireState } from '../states/questionnaire.state';

@Injectable()
export class QuestionsEffects {
  getQuestions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.GET_QUESTIONS),
      withLatestFrom(this._surveySelect.surveyId()),
      switchMap(([, surveyId]) =>
        this._surveyBhUserGrpcContractService
          .getQuestions({
            Value: surveyId,
          })
          .pipe(
            map(({ Questions }) =>
              actions.SET_QUESTIONS({
                questions: (Questions ?? []).map((q) => ({
                  Id: q.Data?.Id,
                  Priority: q.Data?.Priority,
                  Title: q.Data?.Title,
                  Description: q.Data?.Description,
                  WhyWeAsk: q.Data?.WhyWeAsk,
                  TypeSystemId: q.Data?.TypeSystemId,
                  Answered: (q.AnsweredIds?.length ?? 0) > 0,
                  Answers: (q.Data?.Answers ?? []).map((a) => ({
                    Id: a.Id,
                    Priority: a.Priority,
                    Title: a.Title,
                    Description: a.Description,
                    ArticleId: a.ArticleId,
                  })),
                })),
              }),
            ),
            catchError((response) =>
              this._errorService.handleApiError(response, 'SurveyBhUserWebGrpcContractClient.GetQuestions'),
            ),
          ),
      ),
    ),
  );

  // setQuestions$ = createEffect(() =>
  //   this._actions$.pipe(
  //     ofType(actions.SET_QUESTIONS),
  //     map(() => CHANGE_ROUTE({ route: 'questions' })),
  //   ),
  // );

  setAnswer$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.ANSWER_QUESTION_COMMAND),
      withLatestFrom(this._surveySelect.surveyId(), this._questionsSelect.isLastQuestion()),
      switchMap(([{ question, answer }, surveyId, isLastQuestion]) => {
        return this._surveyBhUserGrpcContractService
          .provideAnswers({
            SurveyId: surveyId,
            Questions: [
              {
                QuestionId: question.Id,
                AnswerIds: [answer.Id!],
              },
            ],
          })
          .pipe(
            map(() => actions.ANSWER_QUESTION_SUCCESS({ question, answer, isLastQuestion })),
            catchError((response) =>
              this._errorService.handleApiError(response, 'SurveyBhUserWebGrpcContractClient.ProvideAnswers'),
            ),
          );
      }),
    ),
  );

  answeredAllQuestions$ = createEffect(() =>
    this._actions$.pipe(
      ofType(actions.ANSWER_QUESTION_SUCCESS),
      filter((x) => !!x.isLastQuestion),
      map(() => CALCULATE_AND_GET_RESULTS_COMMAND()),
    ),
  );

  constructor(
    private _store$: Store<IQuestionnaireState>,
    private _actions$: Actions,
    private _questionsSelect: QuestionsSelectService,
    private _questionnaireSelect: QuestionnaireSelectService,
    private _surveyBhUserGrpcContractService: SurveyBhUserGrpcContractService,
    private _surveySelect: SurveySelectService,
    private _errorService: ErrorService,
  ) {}
}
